/* EBMINI CRO: sticky add-to-cart bar with its quick choice window, and product info column helper. */
(function () {
  if (customElements.get('ebm-sticky-atc')) return;

  // When the sticky product info column is taller than the window, let it stick by its
  // bottom edge instead of its top, so the add-to-cart button is never cut off.
  const fitStickyInfo = () => {
    document.querySelectorAll('.product__info-container.product__column-sticky').forEach((element) => {
      if (element.closest('quick-add-modal')) return;
      const room = window.innerHeight - element.offsetHeight - 20;
      element.style.top = room < 30 ? `${room}px` : '';
    });
  };

  const stickyInfoObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(fitStickyInfo);

  const watchStickyInfo = () => {
    fitStickyInfo();
    document
      .querySelectorAll('.product__info-container.product__column-sticky')
      .forEach((element) => stickyInfoObserver?.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchStickyInfo);
  } else {
    watchStickyInfo();
  }
  window.addEventListener('resize', fitStickyInfo);

  class EbmStickyAtc extends HTMLElement {
    connectedCallback() {
      // Never show the bar inside a quick add modal.
      if (this.closest('quick-add-modal')) {
        this.remove();
        return;
      }

      // Live at the end of <body> so no section can cover the bar.
      if (this.parentElement !== document.body) {
        document.querySelectorAll('ebm-sticky-atc').forEach((element) => {
          if (element !== this) element.remove();
        });
        document.body.appendChild(this);
        return;
      }

      this.sectionId = this.dataset.section;
      this.button = this.querySelector('[data-ebm-sticky-btn]');
      this.priceElement = this.querySelector('[data-ebm-sticky-price]');
      this.variantElement = this.querySelector('[data-ebm-sticky-variant]');
      this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      if (!this.button || !this.mainButton) return;

      this.productInfo = this.mainButton.closest('product-info') || document;
      watchStickyInfo();
      this.sizeTouched = false;
      this.scrollFrame = null;

      this.onChange = (event) => {
        const picker = event.target.closest('.ebm-size-picker');
        if (picker && this.productInfo.contains(picker)) {
          this.sizeTouched = true;
          this.sync();
        }
      };
      this.onClick = () => this.handleClick();

      document.addEventListener('change', this.onChange);
      this.button.addEventListener('click', this.onClick);
      this.setUpSheet();

      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.toggle();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.toggle();

      this.mutationObserver = new MutationObserver(() => this.sync());
      this.mutationObserver.observe(this.mainButton, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          this.sync();
          setTimeout(() => this.sync(), 700);
        });
      }

      this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.mutationObserver?.disconnect();
      if (this.unsubscribe) this.unsubscribe();
      this.closeSheet();
      document.documentElement.classList.remove('ebm-sticky-visible');
    }

    get sizePicker() {
      return this.productInfo.querySelector('.ebm-size-picker');
    }

    get mainDisabled() {
      return this.mainButton.hasAttribute('disabled');
    }

    // Option groups of the product form. While the theme swaps variant markup the old and the
    // new picker coexist, so only the first one counts.
    get pickers() {
      const selects = this.productInfo.querySelector('variant-selects');
      return selects ? Array.from(selects.querySelectorAll('fieldset.product-form__input')) : [];
    }

    // The bar appears only once the visitor has scrolled past the main button, never above it.
    toggle() {
      const visible = this.mainButton.getBoundingClientRect().bottom < 0;
      this.classList.toggle('is-visible', visible);
      document.documentElement.classList.toggle('ebm-sticky-visible', visible);
    }

    sync() {
      const needsSize = Boolean(this.sizePicker) && !this.sizeTouched;
      let label = this.dataset.labelAdd;
      if (this.mainDisabled) {
        label = this.mainButton.querySelector('span')?.textContent.trim() || this.dataset.labelSoldOut;
      } else if (needsSize) {
        label = this.dataset.labelChoose;
      }
      if (this.button.textContent.trim() !== label) this.button.textContent = label;

      const price = document.getElementById(`price-${this.sectionId}`);
      const priceItem =
        price?.querySelector('.price--on-sale .price__sale .price-item--sale') ||
        price?.querySelector('.price__regular .price-item--regular');
      const priceText = priceItem ? priceItem.textContent.trim() : '';
      if (priceText && this.priceElement) this.priceElement.textContent = priceText;

      // The thumbnail follows the selected colour.
      const image = this.querySelector('.ebm-sticky-atc__img');
      const colorImage = this.productInfo.querySelector('.ebm-color-picker input:checked + label img');
      const colorSource = colorImage ? colorImage.currentSrc || colorImage.src : '';
      if (image && colorSource && image.src !== colorSource) image.src = colorSource;

      if (this.variantElement) {
        const values = new Map();
        this.pickers.forEach((fieldset) => {
          const input = fieldset.querySelector('input:checked');
          if (!input || values.has(input.name)) return;
          values.set(input.name, fieldset.classList.contains('ebm-size-picker') ? input.value.split(' ')[0] : input.value);
        });
        if (values.size) this.variantElement.textContent = Array.from(values.values()).join(' / ');
      }

      if (this.sheet && this.sheet.open) {
        if (priceText && this.sheetPrice) this.sheetPrice.textContent = priceText;
        if (this.sheetImage && colorSource && this.sheetImage.src !== colorSource) this.sheetImage.src = colorSource;
        if (this.sheetSubmit.textContent.trim() !== label) this.sheetSubmit.textContent = label;
        this.sheetSubmit.toggleAttribute('disabled', this.mainDisabled);
        this.renderSheet();
      }
    }

    handleClick() {
      if (this.sheet && this.pickers.length && typeof this.sheet.showModal === 'function') {
        this.openSheet();
        return;
      }

      const picker = this.sizePicker;
      if (this.mainDisabled || (picker && !this.sizeTouched)) {
        const target = picker || this.mainButton;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (picker) this.highlight(picker);
        return;
      }
      this.mainButton.click();
    }

    highlight(picker) {
      picker.classList.add('ebm-attention');
      setTimeout(() => picker.classList.remove('ebm-attention'), 1800);
    }

    /* --- Quick choice window ------------------------------------------------ */

    setUpSheet() {
      this.sheet = this.querySelector('[data-ebm-sheet]');
      if (!this.sheet || this.sheetReady) return;
      this.sheetReady = true;
      this.sheetOptions = this.sheet.querySelector('[data-ebm-sheet-options]');
      this.sheetSubmit = this.sheet.querySelector('[data-ebm-sheet-submit]');
      this.sheetPrice = this.sheet.querySelector('[data-ebm-sheet-price]');
      this.sheetImage = this.sheet.querySelector('[data-ebm-sheet-img]');

      this.sheetOptions.addEventListener('change', (event) => this.handleSheetChange(event));
      this.sheetSubmit.addEventListener('click', () => this.handleSheetSubmit());
      this.sheet.addEventListener('click', (event) => {
        // A click on the dialog element itself is a click on the backdrop.
        if (event.target === this.sheet || event.target.closest('[data-ebm-sheet-close]')) this.closeSheet();
      });
      this.sheet.addEventListener('close', () => document.documentElement.classList.remove('ebm-sheet-open'));
    }

    openSheet() {
      if (this.sheet.open) return;
      this.sheet.showModal();
      document.documentElement.classList.add('ebm-sheet-open');
      this.sync();
    }

    closeSheet() {
      if (this.sheet && this.sheet.open) this.sheet.close();
    }

    // The window shows a copy of the pickers of the product form. A choice made in the copy is
    // passed on to the real picker, so price, stock and photos stay in the theme's hands.
    renderSheet() {
      const focusedId = this.sheetOptions.contains(document.activeElement) ? document.activeElement.id : '';
      const fragment = document.createDocumentFragment();

      this.pickers.forEach((fieldset) => {
        const copy = fieldset.cloneNode(true);
        const untouchedSize = copy.classList.contains('ebm-size-picker') && !this.sizeTouched;
        const sources = fieldset.querySelectorAll('input');
        copy.classList.remove('ebm-attention');

        copy.querySelectorAll('input').forEach((input, index) => {
          const source = sources[index];
          input.dataset.ebmSource = input.id;
          input.id = `ebm-sheet-${input.id}`;
          input.name = `ebm-sheet-${input.name}`;
          input.removeAttribute('form');
          input.checked = Boolean(source && source.checked) && !untouchedSize;
        });
        copy.querySelectorAll('label[for]').forEach((label) => {
          label.setAttribute('for', `ebm-sheet-${label.getAttribute('for')}`);
        });
        if (untouchedSize) {
          const selected = copy.querySelector('[data-selected-value]');
          if (selected) selected.textContent = '';
        }
        fragment.appendChild(copy);
      });

      this.sheetOptions.replaceChildren(fragment);
      if (focusedId) document.getElementById(focusedId)?.focus({ preventScroll: true });
    }

    handleSheetChange(event) {
      const input = event.target;
      const sourceId = input.dataset ? input.dataset.ebmSource : '';
      if (!sourceId) return;
      if (input.closest('.ebm-size-picker')) this.sizeTouched = true;

      const selects = this.productInfo.querySelector('variant-selects');
      const source = selects ? Array.from(selects.querySelectorAll('input')).find((item) => item.id === sourceId) : null;
      if (source && !source.checked) {
        source.click();
      } else {
        this.sync();
      }
    }

    handleSheetSubmit() {
      if (this.mainDisabled) return;
      const picker = this.sheetOptions.querySelector('.ebm-size-picker');
      if (picker && !this.sizeTouched) {
        this.highlight(picker);
        return;
      }
      this.closeSheet();
      this.mainButton.click();
    }
  }

  customElements.define('ebm-sticky-atc', EbmStickyAtc);
})();
